import React from 'react';

export function CopyToClipboard({ color }: { color: 'blue' | 'gray' }) {
  const fill = color === 'blue' ? '#2563EB' : '#9CA3AF';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M12.3748 2.35H11.9998V2.1C11.9998 1.525 11.5498 1.075 10.9998 1.075H9.5748V0.999999C9.5748 0.699999 8.3248 0.424999 7.9998 0.424999C7.6998 0.424999 6.4248 0.674999 6.4248 0.999999V1.075H4.9998C4.4498 1.075 3.9998 1.525 3.9998 2.1V2.35H3.6248C2.8248 2.35 2.1748 3.025 2.1748 3.825V14.075C2.1748 14.9 2.8248 15.55 3.6248 15.55H12.3998C13.1998 15.55 13.8498 14.875 13.8498 14.075V3.825C13.8248 3 13.1748 2.35 12.3748 2.35ZM5.1248 2.2H10.8748V2.9V3.6H5.1248V2.2ZM12.6998 14.075C12.6998 14.275 12.5498 14.425 12.3748 14.425H3.6248C3.4498 14.425 3.2998 14.275 3.2998 14.075V3.825C3.2998 3.625 3.4498 3.475 3.6248 3.475H3.9998V3.725C3.9998 4.3 4.4498 4.75 4.9998 4.75H10.9998C11.5498 4.75 11.9998 4.3 11.9998 3.725V3.475H12.3998C12.5748 3.475 12.7248 3.625 12.7248 3.825V14.075H12.6998Z"
        fill={fill}
      />
    </svg>
  );
}
